import { differenceInYears } from 'date-fns';

import { parseCalendarDate } from '../date.ts';

export const getAgeFromBirthday = (birthDate: string) => {
  const parsed = parseCalendarDate(birthDate);

  if (!parsed) {
    return '';
  }

  return differenceInYears(new Date(), parsed);
};
